var render, staticRenderFns
import script from "./SchoolRecruitment.vue?vue&type=script&lang=js&"
export * from "./SchoolRecruitment.vue?vue&type=script&lang=js&"
import style0 from "./SchoolRecruitment.vue?vue&type=style&index=0&id=32d92a78&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports